//
//
//
//
//

import VFormRender from '@/components/form-render/index';
import { getDashboardDesign } from '@/api/chart';
export default {
  name: 'Dashboard',
  components: {
    VFormRender: VFormRender
  },
  data: function data() {
    return {
      designer: {},
      chartId: '',
      loading: false
    };
  },
  watch: {},
  created: function created() {
    var routeString = this.$route.path;
    var routeArray = routeString.split('/').filter(function (item) {
      return item !== '';
    });
    this.chartId = routeArray[3];
    this.initFormConfig('chartData');
  },
  methods: {
    initFormConfig: function initFormConfig(key) {
      var _this = this;
      this.loading = true;
      getDashboardDesign(this.chartId).then(function (res) {
        var blankFormJson = JSON.parse(res.data[key]);
        _this.$set(_this, 'designer', blankFormJson);
        _this.loading = false;
      });
    }
  }
};